import ProfileImage from "common/components/ui/ProfileImage";
import type { Certification } from "common/types";

import { formatMonthAndYear, formatRange } from "../../utils";
import SectionContainer from "./SectionContainer";
import SectionItem from "./SectionItem";

import CertificationsFallbackImage from "assets/images/profile-placeholders/certificate.png";

export default function Certifications({
  certification,
}: {
  certification: Certification[];
}) {
  return (
    <SectionContainer title="Licenses & certifications">
      {certification.map(({ name, id, issued, authority, expires }, index) => (
        // biome-ignore lint/suspicious/noArrayIndexKey: no unique key
        <SectionItem key={index}>
          <div className="flex items-start gap-x-2">
            <ProfileImage
              src={authority?.logo_url}
              className="rounded-2xl"
              fallbackImage={CertificationsFallbackImage}
            />
            <div className="flex flex-col items-start">
              <span className="mb-0.5 text-sm-bold">{name}</span>
              {authority && (
                <span className="text-xs-medium text-black-500">
                  {authority.name}
                </span>
              )}
              {id && (
                <span className="text-xs-medium text-black-500">
                  Credential ID: {id}
                </span>
              )}
            </div>
            {(issued || expires) && (
              <span className="ml-auto text-button-xxs text-black-500">
                {formatRange(
                  `Issued ${formatMonthAndYear(issued)}`,
                  expires
                    ? `Expires ${formatMonthAndYear(expires)}`
                    : "No Expiration Date",
                )}
              </span>
            )}
          </div>
        </SectionItem>
      ))}
    </SectionContainer>
  );
}
